export const CROATIAN_LOCATION_LABELS: Record<string, string> = {
    'Izven Slovenije - Hrvaška': 'Izvan Slovenije - Hrvatska',
    'Dubrovniško-neretvanska': 'Dubrovačko-neretvanska',
    'Zagreb mesto': 'Grad Zagreb',
    'Karlovška': 'Karlovačka',
    'Koprivniško-križevska': 'Koprivničko-križevačka',
    'Liško-senjska': 'Ličko-senjska',
    'Medžimurska': 'Međimurska',
    'Osiješko-baranjska': 'Osječko-baranjska',
    'Sisaško-moslavška': 'Sisačko-moslavačka',
    'Virovitiško-podravska': 'Virovitičko-podravska',
    'Vukovarsko-sremska': 'Vukovarsko-srijemska',
    'Zagrebška': 'Zagrebačka',
};

export function croatianLocationLabel(name: string): string {
    return CROATIAN_LOCATION_LABELS[name] ?? name;
}
